import React, { useEffect, useMemo, useState } from 'react';
import Application from '../../Application';

const baseButton: React.CSSProperties = {
    background: '#c0c0c0',
    border: 'none',
    boxShadow:
        'inset -1px -1px #2b2b2b, inset 1px 1px #fff, inset -2px -2px #808080, inset 2px 2px #c0c0c0',
    padding: '6px 14px',
    fontSize: 13,
    fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Microsoft YaHei", sans-serif',
    cursor: 'pointer',
    color: '#000',
    minWidth: 96,
    height: 30,
    lineHeight: 1,
};

const sunkenButton: React.CSSProperties = {
    ...baseButton,
    boxShadow:
        'inset -1px -1px #fff, inset 1px 1px #2b2b2b, inset -2px -2px #c0c0c0, inset 2px 2px #808080',
};

const CameraToolbar: React.FC = () => {
    const app = useMemo(() => new Application(), []);
    const [autoZoom, setAutoZoom] = useState(true);
    const [modelFreeMode, setModelFreeMode] = useState(false);

    useEffect(() => {
        const sync = () => {
            setModelFreeMode(Boolean(app.world?.isModelFreeMode()));
        };
        sync();

        const observer = new MutationObserver(sync);
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        return () => observer.disconnect();
    }, [app]);

    const onSnap = () => {
        app.world?.snapToFront(true);
    };

    const onToggle = () => {
        const next = !autoZoom;
        setAutoZoom(next);
        app.world?.setAutoZoom(next);
    };

    const onToggleModel = () => {
        const next = !modelFreeMode;
        const applied = app.world?.setModelFreeMode(next);
        if (applied) setModelFreeMode(next);
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 16,
                left: 16,
                display: 'flex',
                flexDirection: 'row',
                gap: 6,
                zIndex: 99996,
            }}
        >
            <button onClick={onSnap} style={baseButton}>
                正面视角
            </button>
            <button onClick={onToggle} style={autoZoom ? sunkenButton : baseButton}>
                {autoZoom ? '自动吸附: 开' : '自动吸附: 关'}
            </button>
            <button onClick={onToggleModel} style={baseButton}>
                {modelFreeMode ? '恢复模型' : '取消模型'}
            </button>
        </div>
    );
};

export default CameraToolbar;
